import React from "react";
import { Layout } from "antd";
import TopBar from "./TopBar";
import Header from "./Header";
import ApplicationForm from "./ApplicationForm";
import Footer from "./Footer";
import { Routes, Route } from "react-router-dom";
import "./SimpleApply.scss";

const { Content } = Layout;

const SimpleApply = (props) => {
  return (
    <Layout className="simple-apply-layout">
      <TopBar />
      <Header />
      <Content>
        <Routes>
          <Route
            exact
            path="/"
            id="form"
            element={<ApplicationForm key="form" {...props} />}
          />
          <Route
            exact
            path="/thank-you"
            id="thank-you"
            element={
              <ApplicationForm key="thank-you" {...props} isThanks={true} />
            }
          />
        </Routes>
      </Content>
      <Footer />
    </Layout>
  );
};

export default SimpleApply;
